import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "anchorRef", "position", "setPosition", "isVisible", "triggerRect", "onDismiss", "dismissOnClickOutside", "unmountChildrenOnClose", "style", "children", "center", "arrowProps", "htmlProps", "forceStaticYAxisPosition"];
import { forwardRef, useEffect, useRef } from 'react';
import { useMountChildrenValidation } from '@crehana/react-hooks';
import { clsx } from 'clsx';

// import { renderTriangleBasedOnCollisionsAndPosition } from "../Tooltip/Triangles";
import useRect from "../helpers/useRect";
import _getPosition from "../Tooltip/helpers/getPosition";
import getStylesAndCollissions from "../Tooltip/helpers/getStylesAndCollissions";
import { jsx as _jsx } from "react/jsx-runtime";
var PopperContent = function PopperContent(_ref, forwardedRef) {
  var className = _ref.className,
    anchorRef = _ref.anchorRef,
    position = _ref.position,
    _ref$setPosition = _ref.setPosition,
    setPosition = _ref$setPosition === void 0 ? _getPosition : _ref$setPosition,
    isVisible = _ref.isVisible,
    triggerRect = _ref.triggerRect,
    onDismiss = _ref.onDismiss,
    dismissOnClickOutside = _ref.dismissOnClickOutside,
    unmountChildrenOnClose = _ref.unmountChildrenOnClose,
    style = _ref.style,
    children = _ref.children,
    center = _ref.center,
    arrowProps = _ref.arrowProps,
    htmlProps = _ref.htmlProps,
    forceStaticYAxisPosition = _ref.forceStaticYAxisPosition,
    popperContentProps = _objectWithoutProperties(_ref, _excluded);
  var ownRef = useRef(null);
  var ref = forwardedRef || ownRef;
  var tooltipRect = useRect(ownRef, isVisible);
  var shouldMountChildren = useMountChildrenValidation({
    isOpen: isVisible,
    unmountChildrenOnClose: unmountChildrenOnClose
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    var listener = function listener(event) {
      if (onDismiss && ref && typeof ref !== 'function' && ref.current && !ref.current.contains(event.target) && (!anchorRef || !anchorRef.current || !anchorRef.current.contains(event.target))) {
        onDismiss();
      }
    };
    if (dismissOnClickOutside) {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
    } else {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    }
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissOnClickOutside, onDismiss]);

  // const canShowArrow = arrowProps && arrowProps.visible !== false;

  var _getStylesAndCollissi = getStylesAndCollissions(setPosition, triggerRect, tooltipRect, position),
    _getStylesAndCollissi2 = _slicedToArray(_getStylesAndCollissi, 1),
    absolutePositionStyles = _getStylesAndCollissi2[0];
  var left = center && position && ['top', 'bottom'].includes(position) ? +triggerRect.left + +triggerRect.width / 2 - +tooltipRect.width / 2 : absolutePositionStyles.left;
  var top = center && position && ['left', 'right'].includes(position) || forceStaticYAxisPosition ? +triggerRect.top + +triggerRect.height / 2 - +tooltipRect.height / 2 + (forceStaticYAxisPosition ? 24 : 0) : absolutePositionStyles.top;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
    role: "tooltip",
    style: _objectSpread(_objectSpread({}, style), {}, {
      left: "calc(".concat(left, "px + 2px)"),
      top: "calc(".concat(top, "px - 4px)")
    }),
    ref: ref,
    className: clsx('tw-absolute tw-z-dialog tw-whitespace-no-wrap tw-rounded-1.2', 'tw-shadow-03 tw-bg-neutral-light-100 tw-text-neutral-light-800', 'dark:tw-text-neutral-light-100 dark:tw-bg-elevation-dark-04 dark:tw-shadow-none', className)
  }, popperContentProps), htmlProps), {}, {
    children: shouldMountChildren && children
  }));
};
export default /*#__PURE__*/forwardRef(PopperContent);